import moment from "moment";
import { useEffect, useRef } from "react";
import type { ProcedureType, SourcingEventV2PatchDto } from "../../../../../autogen/bff-api";
import { isQualificationScheme, isTwoStageProcedure } from "../utils/procedure";

const SUGGESTED_REQUEST_DEADLINE_DAYS = 35;

const suggestedRequestDeadlineIso = (): string =>
  moment()
    .add(SUGGESTED_REQUEST_DEADLINE_DAYS, "days")
    .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
    .toISOString();

interface SuggestedRequestDeadline {
  procedureType: ProcedureType | null;
  requestDeadline: string | null;
  isSaving: boolean;
  updateField: (fields: Partial<SourcingEventV2PatchDto>) => void;
}

export const useSuggestedRequestDeadline = ({
  procedureType,
  requestDeadline,
  isSaving,
  updateField,
}: SuggestedRequestDeadline): void => {
  const seededRef = useRef(false);

  useEffect(() => {
    if (seededRef.current) return;
    if (!isTwoStageProcedure(procedureType)) return;
    // § 13-1: a qualification scheme has no request deadline to suggest.
    if (isQualificationScheme(procedureType)) return;
    if (requestDeadline !== null) return;
    if (isSaving) return;
    seededRef.current = true;
    updateField({
      eventData: {
        requestDeadline: suggestedRequestDeadlineIso(),
        requestDeadlineConfirmed: false,
      },
    });
  }, [procedureType, requestDeadline, isSaving, updateField]);
};
